import { useState } from "react";
import styles from "./categoryData.module.css";
import { Tab, Tabs } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  categoryApi,
  useGetAllCategoryQuery,
} from "../../../features/api/category/categoryApi";
import { AddCategory } from "../addCategory/AddCategory";

export const CategoryData = () => {
  const [key, setKey] = useState("Category List");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);

  // Fetching data from API
  const { data, isLoading, isError } = useGetAllCategoryQuery();

  return (
    <div className="container pt-5">
      <Tabs
        id="controlled-tab"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="Category List" title="Category List">
          <div className={styles.tableContainer}>
            {isLoading ? (
              <p>Loading...</p>
            ) : isError ? (
              <p>Error fetching data</p>
            ) : (
              <>
                <table className={styles.customTable}>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Category </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? (
                      data.map((category, idx) => (
                        <tr
                          key={category.id}
                          // onClick={() => navigate(`/category/${category.id}`)}
                        >
                          <td>{idx + 1}</td>
                          <td className={styles.itemName}>{category.name}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2" className={styles.noData}>
                          No category found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </>
            )}
          </div>
        </Tab>

        <Tab eventKey="Add Category" title="Add Category">
          <AddCategory onSuccess={() => setKey("Category List")} />
        </Tab>
      </Tabs>
    </div>
  );
};
